import { useMemo } from 'react';
import type { AccommodationHotelsQuery } from '../Accommodations.graphql.generated';

import { sortByFavorite, sortByHostStayingHere, sortByOrderList } from '@shared/utils/array';
import { generateAccommodationList } from '../utils/Accommodations.utils';
import { useEventPlaces } from '@shared/utils/eventPlace';

interface GetAccommodationsDataProps {
  blockOrderingInitial?: string[] | null;
  accommodations: AccommodationHotelsQuery['eventByName'];
}

export function useSortedAccommodationsData(props: GetAccommodationsDataProps) {
  const { accommodations, blockOrderingInitial } = props;
  const { origin } = useEventPlaces();

  // `origin` from useEventPlaces() is a new object reference on every render (not memoized
  // upstream). Depend on its primitive values so the memo only recomputes when the actual
  // venue coordinates change — not on every parent re-render.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const allHotels = useMemo(() => generateAccommodationList(accommodations, origin), [accommodations, origin?.latitude, origin?.longitude]);

  const accommodationHotels = useMemo(() => sortByFavorite(sortByHostStayingHere(sortByOrderList(allHotels ?? [], blockOrderingInitial ?? []))), [blockOrderingInitial, allHotels]);

  const hasFavoriteHotel = useMemo(() => !!(accommodationHotels && accommodationHotels.find(hotel => hotel.isFavorite)), [accommodationHotels]);

  return { accommodationHotels, blockOrdering: accommodationHotels?.map(acc => acc.id), hasFavoriteHotel };
}
